/**
 * Filters navigation items based on the user's permissions.
 * Items with a `permission` field are kept only if the user has that permission.
 * Items without a `permission` field are shown to everyone.
 */
import { hasPermission } from './rbac.util';

export function filterNavByPermissions(items: any[], permissions: string[]): any[] {
  return items.reduce((acc: any[], item: any) => {
    if (item.permission && !hasPermission(permissions, item.permission)) return acc;

    if (item.children?.length) {
      const children = filterNavByPermissions(item.children, permissions);
      if (!children.length) return acc;
      acc.push(children.length === item.children.length ? item : { ...item, children });
    } else {
      acc.push(item);
    }
    return acc;
  }, []);
}